import classNames from "classnames";
import styles from "./style.module.scss";
import SkeletonLoader from "shared/loaders/skeleton";
import { Link } from "react-router-dom";

interface IStatsCard {
  count: number;
  icon?: React.ReactNode;
  title: string;
  loading?: boolean;
  linkPath?: any;
}

const StatsCard = ({ count, icon, title, loading, linkPath }: IStatsCard) => {
  return (
    <Link to={linkPath} className={classNames(styles.stats_item)}>
      <div className="flex justify-between items-start">
        {loading ? (
          <SkeletonLoader className={classNames(styles.loader)} />
        ) : (
          <h1 className={classNames(styles.count)}>{count}</h1>
        )}

        <span className={classNames(styles.iconContainer)}>{icon}</span>
      </div>
      <h2 className={classNames(styles.title)}>{title}</h2>
    </Link>
  );
};

export default StatsCard;
